import { render, staticRenderFns } from "./company_list.vue?vue&type=template&id=2b960c60&scoped=true&"
import script from "./company_list.vue?vue&type=script&lang=js&"
export * from "./company_list.vue?vue&type=script&lang=js&"
import style0 from "./company_list.vue?vue&type=style&index=0&id=2b960c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b960c60",
  null
  
)

export default component.exports